import { Component } from './component.js';
import { ControlButton } from '../../ui/2.0/control-button.js';
import { LoadSpinner } from '../../ui/2.0/load-spinner.js';
import { PanoramicView } from '../../ui/2.0/panoramic-view.js';
import { CAUI } from './ca-ui.js';
import { ControlButtonContainer } from './control-button-container';

const TWEEN = require('@tweenjs/tween.js');

export class BeforeAfterSlider extends Component {
  static defaultOptions = {
    componentName: 'BeforeAfterSlider',
    before: {
      media: null,
      label: {
        text: 'Before',
        backgroundColor: '#000000b5',
        opacity: 0.8,
        padding: '6px 10px',
        color: 'white',
        fontSize: 20,
        fontFamily: 'Roboto,sans-serif',
        fontWeight: 300
      }
    },
    after: {
      media: null,
      label: {
        text: 'After',
        backgroundColor: '#000000b5',
        opacity: 0.8,
        padding: '6px 10px',
        color: 'white',
        fontSize: 20,
        fontFamily: 'Roboto,sans-serif',
        fontWeight: 300
      }
    },
    orientation: 'horizontal',
    showZoom: false,
    showFullscreen: false,
    panoramic: {
      enabled: false,
      hfov: 120,
      minHfov: 30,
      maxHfov: 120
    }
  };

  constructor (options) {
    super($.extend({}, BeforeAfterSlider.defaultOptions, options));

    this.options.before = $.extend(
      {},
      BeforeAfterSlider.defaultOptions.before,
      this.options.before
    );
    this.options.before.label = $.extend(
      {},
      BeforeAfterSlider.defaultOptions.before.label,
      this.options.before.label
    );
    this.options.after = $.extend(
      {},
      BeforeAfterSlider.defaultOptions.after,
      this.options.after
    );
    this.options.after.label = $.extend(
      {},
      BeforeAfterSlider.defaultOptions.after.label,
      this.options.after.label
    );

    if (this.options.panoramic === true) {
      this.options.panoramic = $.extend(
        { enabled: true },
        BeforeAfterSlider.defaultOptions.panoramic
      );
      this.options.panoramic.enabled = true;
    }

    this.zoomLevel = 1;
    this.loadedHd = false;
    this.position = { x: 0, y: 0 };
    this.mouseDownPos = { x: 0, y: 0 };
    this.imgOffset = { x: 0, y: 0 };
    this.fullscreen = false;
    this.isPanoramic = this.options.panoramic.enabled;

    this.container = $(
      '<div class="' + this.getComponentClass() + '_container' + '"></div>'
    );
    this.el.append(this.container);

    // Load spinner
    this.loadSpinner = new LoadSpinner({
      label: 'Loading before & after image...'
    });
    this.container.append(this.loadSpinner.el);

    // Controls
    this.controlsContainer = new ControlButtonContainer({});
    this.el.append(this.controlsContainer.el);

    if (this.options.showZoom) {
      this.zoomControlGroup = $(
        '<div class="ca-ui_control-group ' +
          this.getComponentClass() +
          '_zoomcontrols' +
          '"></div>'
      );
      this.controlsContainer.el.append(this.zoomControlGroup);

      this.zoomInControl = new ControlButton({
        icon: 'search-plus',
        tooltip: 'Zoom in'
      });
      this.zoomControlGroup.append(this.zoomInControl.el);
      this.zoomInControl.on(
        'click touchstart',
        function () {
          this.zoomIn();
        }.bind(this)
      );

      this.zoomOutControl = new ControlButton({
        icon: 'search-minus',
        tooltip: 'Zoom out'
      });
      this.zoomOutControl.el.prop('disabled', true);
      this.zoomControlGroup.append(this.zoomOutControl.el);
      this.zoomOutControl.on(
        'click touchstart',
        function () {
          this.zoomOut();
        }.bind(this)
      );
    }

    if (this.options.showFullscreen && CAUI.isFullscreenEnabled()) {
      this.fullscreenControl = new ControlButton({
        icon: 'expand',
        tooltip: 'Fullscreen'
      });
      this.controlsContainer.add(this.fullscreenControl);
      this.fullscreenControl.on(
        'click touchstart',
        function () {
          CAUI.enterFullscreen(!this.fullscreen, this.el[0]);
          this.fullscreen = !this.fullscreen;

          this.fullscreenControl.setIcon(
            this.fullscreen ? 'compress' : 'expand'
          );
          this.fullscreenControl.setTooltip(
            this.fullscreen ? 'Exit fullscreen' : 'Fullscreen'
          );
          this.layout();
          // this.moveImage();
        }.bind(this)
      );
    }

    // Placeholder
    this.placeholder = $(
      '<img class="' +
        this.getComponentClass() +
        '_placeholder' +
        '" src="' +
        this.options.after.media +
        '?w=400&blur=50" />'
    );
    this.placeholder.on(
      'load',
      function () {
        this.layout();
      }.bind(this)
    );
    this.container.append(this.placeholder);

    // Handle
    this.handle = new BeforeAfterSliderHandle();
    this.container.append(this.handle.el);

    this.mouseDownHandler = function (e) {
      if (!this.loaded) return;

      this.mouseDownPos = this.getMouseTouchPosition(e);

      // Before/after-ing
      if (jQuery.contains(this.handle.el[0], e.target)) {
        $('body').css('cursor', 'ew-resize');

        this.handle.setMouseDown(true);
        this.startDragging = true;
      // eslint-disable-next-line brace-style
      }

      // Panning
      else {
        $('body').css('cursor', 'grabbing');

        if (this.zoomLevel === 1) return;
        this.startPanning = true;

        this.imgRect = this.beforeImg[0].getBoundingClientRect();
        this.mouseDownPos.x -= this.imgOffset.x;
        this.mouseDownPos.y -= this.imgOffset.y;
      }

      $(window).on('mouseup touchend', this.mouseUpHandler);
      $(window).on('mousemove touchmove', this.mouseMoveHandler);
    }.bind(this);
    this.el.on('mousedown touchstart', this.mouseDownHandler);

    this.mouseUpHandler = function (e) {
      $('body').css('cursor', 'default');

      if (this.dragging) {
        this.handle.setMouseDown(false);
        e.preventDefault();
        this.stopDragging();
        this.el.removeClass(this.getComponentClass() + '--dragging');
      } else if (this.panning) {
        e.preventDefault();
        this.stopPanning();
        this.el.removeClass(this.getComponentClass() + '--panning');
      }

      $(window).off('mouseup touchend', this.mouseUpHandler);
      $(window).off('mousemove touchmove', this.mouseMoveHandler);
    }.bind(this);

    this.mouseMoveHandler = function (e) {
      const newPos = this.getMouseTouchPosition(e);

      const diffX = this.mouseDownPos.x - newPos.x;
      const diffY = this.mouseDownPos.y - newPos.y;

      if (diffX !== 0 || diffY !== 0) {
        if (this.startDragging) {
          this.startDragging = false;
          this.dragging = true;
          this.el.addClass(this.getComponentClass() + '--dragging');
        } else if (this.startPanning) {
          this.el.addClass(this.getComponentClass() + '--panning');
          this.startPanning = false;
          this.panning = true;
        }
      }

      if (this.dragging) {
        let x = newPos.x - this.containerRect.left;
        x = Math.max(0, x);
        x = Math.min(this.containerRect.width, x);

        this.setPosition(x);
      } else if (this.panning) {
        this.imgOffset.x = newPos.x - this.mouseDownPos.x;
        this.imgOffset.y = newPos.y - this.mouseDownPos.y;

        this.moveImage();
      }
    }.bind(this);

    this.el.on(
      'click touchstart',
      function (e) {
        if (!this.panning) {
          const target = $(e.target);
          if (target.is(this.beforeContainer[0])) {
            this.animateToPosition(
              this.containerRect.width - 100,
              TWEEN.Easing.Quadratic.InOut,
              1500
            );
          } else if (target.is(this.afterContainer[0])) {
            this.animateToPosition(100, TWEEN.Easing.Quadratic.InOut, 1500);
          }
        }
      }.bind(this)
    );

    // Before
    this.beforeContainer = $(
      '<div class="' + this.getComponentClass() + '_before' + '"></div>'
    );
    this.container.append(this.beforeContainer);

    this.beforeLabel = $(
      '<div class="' +
        this.getComponentClass() +
        '_before-label' +
        '" style="background-color:' +
        this.options.before.label.backgroundColor +
        ';color:' +
        this.options.before.label.color +
        ';padding:' +
        this.options.before.label.padding +
        ';font-family:' +
        this.options.before.label.fontFamily +
        ';font-weight:' +
        this.options.before.label.fontWeight +
        ';font-size:' +
        this.options.before.label.fontSize +
        'px;opacity:' +
        this.options.before.label.opacity +
        '">' +
        this.options.before.label.text +
        '</div>'
    );
    this.beforeContainer.append(this.beforeLabel);

    // After
    this.afterContainer = $(
      '<div class="' + this.getComponentClass() + '_after' + '"></div>'
    );
    this.container.append(this.afterContainer);

    this.afterLabel = $(
      '<div class="' +
        this.getComponentClass() +
        '_after-label' +
        '" style="background-color:' +
        this.options.after.label.backgroundColor +
        ';color:' +
        this.options.after.label.color +
        ';padding:' +
        this.options.after.label.padding +
        ';font-family:' +
        this.options.after.label.fontFamily +
        ';font-weight:' +
        this.options.after.label.fontWeight +
        ';font-size:' +
        this.options.after.label.fontSize +
        'px;opacity:' +
        this.options.after.label.opacity +
        '">' +
        this.options.after.label.text +
        '</div>'
    );
    this.afterContainer.append(this.afterLabel);

    // Load images
    this.loadCount = 0;
    this.beforeImg = this.loadImage(
      this.beforeContainer,
      this.options.before.media + '?q=90'
    );
    this.afterImg = this.loadImage(
      this.afterContainer,
      this.options.after.media + '?q=90'
    );

    if (this.isPanoramic) {
      this.beforePano = this.beforeImg;
      this.beforeImg = this.beforeImg.el;
      this.afterPano = this.afterImg;
      this.afterImg = this.afterImg.el;
    }

    $(window).on(
      'resize',
      function () {
        this.layout();
      }.bind(this)
    );
  }

  getMouseTouchPosition (e) {
    if (e.originalEvent.touches) {
      const touch = e.originalEvent.touches[0];
      return { x: touch.pageX, y: touch.pageY };
    }
    return { x: e.clientX, y: e.clientY };
  }

  stopDragging () {
    setTimeout(
      function () {
        this.dragging = false;
      }.bind(this),
      100
    );
  }

  stopPanning () {
    setTimeout(
      function () {
        this.panning = false;
      }.bind(this),
      100
    );
  }

  moveImage () {
    this.imgRect = this.beforeImg[0].getBoundingClientRect();

    const limitX = (this.imgRect.width - this.containerRect.width) / 2;
    const limitY = (this.imgRect.height - this.containerRect.height) / 2;

    this.imgOffset.x = Math.max(this.imgOffset.x, -limitX);
    this.imgOffset.x = Math.min(this.imgOffset.x, limitX);
    this.imgOffset.y = Math.max(this.imgOffset.y, -limitY);
    this.imgOffset.y = Math.min(this.imgOffset.y, limitY);

    this.beforeImg.css('margin-left', this.imgOffset.x);
    this.beforeImg.css('margin-top', this.imgOffset.y);
    this.afterImg.css('margin-left', this.imgOffset.x);
    this.afterImg.css('margin-top', this.imgOffset.y);
  }

  layout () {
    this.imgRect = this.beforeImg[0].getBoundingClientRect();
    this.containerRect = this.container[0].getBoundingClientRect();
    this.setPosition(this.containerRect.width / 2);

    if (this.isPanoramic) {
      this.beforePano.layout();
      this.afterPano.layout();
    }
  }

  zoomIn () {
    this.zoomLevel++;
    this.zoomLevel = Math.min(5, this.zoomLevel);

    this.setZoom(this.zoomLevel);
  }

  zoomOut () {
    this.zoomLevel--;
    this.zoomLevel = Math.max(1, this.zoomLevel);

    this.setZoom(this.zoomLevel);
  }

  setZoom (zoom) {
    if (this.zoomOutControl) this.zoomOutControl.el.prop('disabled', zoom <= 1);
    if (this.zoomInControl) this.zoomInControl.el.prop('disabled', zoom >= 5);

    if (this.zoomLevel > 1) { this.el.addClass(this.getComponentClass() + '--zoomed'); } else this.el.removeClass(this.getComponentClass() + '--zoomed');

    this.zooming = true;
    requestAnimationFrame(this.animate.bind(this));

    setTimeout(
      function () {
        this.zooming = false;
      }.bind(this),
      900
    );

    if (this.isPanoramic) {
      this.beforePano.setZoom(zoom);
    } else {
      if (!this.loadedHd && zoom > 1) {
        this.loadedHd = true;

        this.loadSpinner.show();

        setTimeout(
          function () {
            this.loadHdImage(
              this.beforeImg,
              this.options.before.media + '?p=original&q=80'
            );
            this.loadHdImage(
              this.afterImg,
              this.options.after.media + '?p=original&q=95'
            );
          }.bind(this),
          800
        );
      }

      this.beforeImg.css('transform', 'scale(' + zoom + ')');
      this.afterImg.css('transform', 'scale(' + zoom + ')');
    }
  }

  setPosition (x) {
    this.position.x = x;
    this.handle.el.css('left', x);

    this.beforeContainer.css(
      'clip',
      'rect(0, ' + x + 'px, ' + this.containerRect.height + 'px, 0)'
    );
    this.afterContainer.css(
      'clip',
      'rect(0, ' +
        this.containerRect.width +
        'px, ' +
        this.containerRect.height +
        'px, ' +
        x +
        'px)'
    );
  }

  animateToPosition (x, easing, duration, callback, stopExisting) {
    this.tweening = true;
    requestAnimationFrame(this.animate.bind(this));

    if (this.tween && stopExisting !== false) this.tween.stop();

    this.tween = new TWEEN.Tween(this.position)
      .to({ x: x }, duration || 1000)
      .easing(easing || TWEEN.Easing.Quadratic.In)
      .onUpdate(
        function () {
          this.setPosition(this.position.x);
        }.bind(this)
      )
      .onComplete(
        function () {
          this.false = true;
          if (callback != null) callback.call(this);
        }.bind(this)
      )
      .start();
  }

  loadImage (container, url) {
    if (this.isPanoramic) {
      const panoView = new PanoramicView(
        $.extend(
          {
            media: url,
            onLoad: function () {
              this.loadSpinner.hide();

              this.loadCount++;

              if (this.loadCount === 2) {
                this.loaded = true;
                this.onLoaded();
              }
            }.bind(this),
            onViewChange: function (e) {
              if (e.targetElement === this.beforePano.el[0]) {
                this.afterPano.setView(e);
              } else {
                this.beforePano.setView(e);
              }
            }.bind(this)
          },
          this.options.panoramic
        )
      );
      // this.containerRect = this.el[0].getBoundingClientRect();
      container.append(panoView.el);

      return panoView;
    } else {
      const img = $('<img />')
        .attr('src', url)
        .on(
          'load',
          function () {
            this.loadSpinner.hide();

            if (!this.loadedHd) {
              if (
                !img[0].complete ||
                typeof img[0].naturalWidth === 'undefined' ||
                img[0].naturalWidth === 0
              ) {
                alert('Failed to load before after image: ' + url);
              } else {
                container.append(img);
                this.loadCount++;

                if (this.loadCount === 2) {
                  this.loaded = true;
                  this.onLoaded();
                }
              }
            }
          }.bind(this)
        );
      return img;
    }
  }

  loadHdImage (img, url) {
    img.attr('src', url);
  }

  animate (time) {
    if (this.tweening || this.zooming) { requestAnimationFrame(this.animate.bind(this)); }
    if (this.tweening) TWEEN.update(time);
    if (this.zooming) this.moveImage();
  }

  onLoaded () {
    this.containerRect = this.container[0].getBoundingClientRect();
    const center = this.containerRect.width / 2;

    if (this.zoomControlGroup) this.zoomControlGroup.css('opacity', 1);
    if (this.zoomInControl) this.zoomInControl.css('opacity', 1);
    if (this.zoomOutControl) this.zoomOutControl.css('opacity', 1);
    if (this.fullscreenControl) this.fullscreenControl.css('opacity', 1);

    this.setPosition(center);
    if (this.isPanoramic) this.beforePano.panToStart();
    else this.zoomOut();

    // Hint anit
    setTimeout(
      function () {
        this.animateToPosition(
          center - 100,
          TWEEN.Easing.Quadratic.Out,
          500,
          function () {
            this.animateToPosition(
              center + 100,
              TWEEN.Easing.Quadratic.InOut,
              1000,
              function () {
                this.animateToPosition(
                  center,
                  TWEEN.Easing.Quadratic.In,
                  500,
                  null,
                  false
                );
              }.bind(this),
              false
            );
          }.bind(this),
          false
        );

        this.el.addClass(this.getComponentClass() + '--loaded');
      }.bind(this),
      200
    );

    // Scroll wheel
    if (this.options.showZoom) {
      this.el.bind(
        'mousewheel',
        function (e) {
          if (e.originalEvent.wheelDelta / 120 > 0) this.zoomIn();
          else this.zoomOut();
        }.bind(this)
      );
    }
  }
}

export class BeforeAfterSliderHandle extends Component {
  static defaultOptions = {
    componentName: 'BeforeAfterSliderHandle'
  };

  constructor (options) {
    super($.extend({}, BeforeAfterSliderHandle.defaultOptions, options));

    this.beforeLine = $(
      '<div class="' + this.getComponentClass() + '_beforeline' + '"></div>'
    );
    this.el.append(this.beforeLine);

    this.afterLine = $(
      '<div class="' + this.getComponentClass() + '_afterline' + '"></div>'
    );
    this.el.append(this.afterLine);

    this.grabber = $(
      '<div class="' + this.getComponentClass() + '_grabber' + '"></div>'
    );
    this.el.append(this.grabber);

    this.grabberLeftArrow = $(
      '<i class="' +
        this.getComponentClass() +
        '_grabber_leftarrow' +
        ' fa fa-angle-left"></i>'
    );
    this.grabber.append(this.grabberLeftArrow);

    this.grabberRightArrow = $(
      '<i class="' +
        this.getComponentClass() +
        '_grabber_rightarrow' +
        ' fa fa-angle-right"></i>'
    );
    this.grabber.append(this.grabberRightArrow);
  }

  setMouseDown (mousedown) {
    this.el.toggleClass(this.getComponentClass() + '--dragging', mousedown);
  }
}

(function ($) {
  $.fn.caBeforeAfterSlider = function (options) {
    return this.each(function () {
      // eslint-disable-next-line no-new
      new BeforeAfterSlider($.extend({ element: this }, {}, options));
      return this;
    });
  };
})(jQuery);
